/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MatrixCarePatient } from './MatrixCarePatient';
import {
    MatrixCarePatientFromJSON,
    MatrixCarePatientFromJSONTyped,
    MatrixCarePatientToJSON,
} from './MatrixCarePatient';

/**
 * 
 * @export
 * @interface CreateMatrixCarePatientRequest
 */
export interface CreateMatrixCarePatientRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateMatrixCarePatientRequest
     */
    upload: boolean;
    /**
     * 
     * @type {MatrixCarePatient}
     * @memberof CreateMatrixCarePatientRequest
     */
    patient: MatrixCarePatient;
}

/**
 * Check if a given object implements the CreateMatrixCarePatientRequest interface.
 */
export function instanceOfCreateMatrixCarePatientRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "upload" in value;
    isInstance = isInstance && "patient" in value;

    return isInstance;
}

export function CreateMatrixCarePatientRequestFromJSON(json: any): CreateMatrixCarePatientRequest {
    return CreateMatrixCarePatientRequestFromJSONTyped(json, false);
}

export function CreateMatrixCarePatientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMatrixCarePatientRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'upload': json['upload'],
        'patient': MatrixCarePatientFromJSON(json['patient']),
    };
}

export function CreateMatrixCarePatientRequestToJSON(value?: CreateMatrixCarePatientRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'upload': value.upload,
        'patient': MatrixCarePatientToJSON(value.patient),
    };
}

